import useRoles from '@/views/campus/account-data/useRoles'
import { computed } from '@vue/composition-api'
import store from '@/store/index'

export const rolesActions = {
  setup() {
    const { updateCurrentRole } = useRoles() //* Methods to load roles and change user's rol

    //* Method ready to be called, change the user's role
    const currentRole = selected => { updateCurrentRole(selected) }

    const userRol = computed(() => store.state.cuenta.rolSelected) //* Return current role
    const rolesDisponibles = computed(() => store.state.cuenta.rolesDisponibles) //* Return available roles

    return {
      //* Method ready to be used in another components
      currentRole,

      //* Computed properties ready to be used
      userRol,
      rolesDisponibles,
    }
  },
}

export const _ = null
